module.exports = __webpack_public_path__ + "static/media/r21.a5551c96.jpg";